import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from "ngx-toastr";
import { MultiType, Provider, Reparation, Vehicule, Group } from '../../../model/index';
import { MultiTypeService } from '../../../providers';
import { ProviderService } from '../../../providers/provider-service';
import { ReparationService } from '../../../providers/reparation-service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
    selector: 'app-reparation-form',
    templateUrl: './reparation-form.component.html',
    styleUrls: ['./reparation-form.component.css']
})

export class ReparationFormComponent implements OnInit {

    @Input()
    mode: 'ADD' | 'UPDATE' = 'ADD';

    @Input()
    reparation: Reparation = new Reparation();

    @Input()
    vehicule: Vehicule = new Vehicule();

    @Input()
    group: Group = new Group();

    @Output()
    reparationWasAdded: EventEmitter<Reparation> = new EventEmitter<Reparation>();

    @Output()
    reparationWasUpdated: EventEmitter<Reparation> = new EventEmitter<Reparation>();

    providers: Provider[] = [];

    reparationTypes: MultiType[] = [];
    reparationTypesSugge: MultiType[] = [];

    loading: boolean = false;

    showProvider = false;

    maxDate: Date = new Date();
    searchTextRep:string = '';
    hasSelectRepType:boolean = false;
  @ViewChild('searchDiv') searchDiv!: ElementRef;


  constructor(private reparationService: ReparationService, private providerService: ProviderService, private multiTypeService: MultiTypeService, public toastr: ToastrService, private localeService: BsLocaleService) { }

    ngOnInit() {
        this.localeService.use('fr');
        this.loadProviders();
        //this.loadTypes();
    }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['reparation']) {
      if(this.mode === 'UPDATE'){
        this.searchTextRep = this.reparation.reparationType.name;
        this.hasSelectRepType = false;
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.searchDiv?.nativeElement.contains(event.target)) {
      if(this.searchTextRep?.length > 0 && this.searchTextRep !== this.reparation.reparationType.name && !this.hasSelectRepType ) {
        this.reparation.reparationType.id = 0;
        this.reparation.reparationType.name = this.searchTextRep;
      }
      this.reparationTypesSugge = [];
    }
  }
    /**
     * Charger liste des fournisseurs
     */
    loadProviders() {
        this.providerService.getProviders("MAINTENANCE").subscribe(providers => {
            this.providers = providers;
        }, error => {
            let textError = JSON.parse(JSON.stringify(error.error || null)).errorMessage;
            if (JSON.parse(JSON.stringify(error.error || null)).errors) textError += ' ' + JSON.parse(JSON.stringify(error.error || null)).errors;
            this.toastr.error(textError, JSON.parse(JSON.stringify(error.error || null)).errorCode);
        });
    }

    /**
     * Charger liste des types
     */
    loadTypes() {
        this.multiTypeService.getListType("REPARATION").subscribe(reparationTypes => {
            this.reparationTypes = reparationTypes;
        }, error => {
            let textError = JSON.parse(JSON.stringify(error.error || null)).errorMessage;
            if (JSON.parse(JSON.stringify(error.error || null)).errors) textError += ' ' + JSON.parse(JSON.stringify(error.error || null)).errors;
            this.toastr.error(textError, JSON.parse(JSON.stringify(error.error || null)).errorCode);
        });
    }

    /**
     * Ajouter nouveau réparation
     */
    onAdd(form: NgForm) {
        this.loading = true;
        this.reparationService.add(this.reparation, this.vehicule.idVehicule, this.group.idGroupe).subscribe(reparation => {
            this.toastr.success('Réparation informations bien sauvegarder !', 'info');
            this.reparationWasAdded.emit(reparation);
            this.loading = false;
            form.reset();
            this.loadProviders();
            //this.loadTypes();
        }, error => {
            let textError = JSON.parse(JSON.stringify(error.error || null)).errorMessage;
            if (JSON.parse(JSON.stringify(error.error || null)).errors) textError += ' ' + JSON.parse(JSON.stringify(error.error || null)).errors;
            this.toastr.error(textError, JSON.parse(JSON.stringify(error.error || null)).errorCode);
            this.loading = false;
        });
    }

    /**
     * modifier réparation
     */
    onUpdate(form: NgForm) {
        this.loading = true;
        this.reparationService.update(this.reparation).subscribe(reparation => {
            this.toastr.success('Réparation informations bien sauvegarder !', 'info');
            this.reparationWasUpdated.emit(reparation);
            this.loading = false;
            form.reset();
            this.loadProviders();
            //this.loadTypes();
        }, error => {
            let textError = JSON.parse(JSON.stringify(error.error || null)).errorMessage;
            if (JSON.parse(JSON.stringify(error.error || null)).errors) textError += ' ' + JSON.parse(JSON.stringify(error.error || null)).errors;
            this.toastr.error(textError, JSON.parse(JSON.stringify(error.error || null)).errorCode);
            this.loading = false;
        });
    }

    /**
     * Action change date  opération
     */
    onChangeOperationTime() {
        if (this.reparation.actualRepairTime < this.reparation.operationTime) {
            this.reparation.actualRepairTime = null;
        }
    }

  searchRep(){
    this.hasSelectRepType = false;
    const res = this.reparationTypes.filter(t => t.name.toLowerCase().includes(this.searchTextRep.toLowerCase()));
    if(res.length > 0){
      this.reparationTypesSugge = res;
    }
    else {
      this.multiTypeService.searchType("REPARATION",this.searchTextRep).subscribe({
        next:(reparationTypes) => {
          this.reparationTypes = reparationTypes;
          this.reparationTypesSugge = reparationTypes;
        },
        error:(error) => {
          let textError = JSON.parse(JSON.stringify(error.error || null)).errorMessage;
          if (JSON.parse(JSON.stringify(error.error || null)).errors) textError += ' ' + JSON.parse(JSON.stringify(error.error || null)).errors;
          this.toastr.error(textError, JSON.parse(JSON.stringify(error.error || null)).errorCode);
        }
      });
    }
  }

  selectRepType(type:MultiType){
    this.hasSelectRepType = true;
    this.reparation.reparationType.id = type.id;
    this.reparation.reparationType.name = type.name;
    this.searchTextRep = type.name;
    this.reparationTypesSugge = [];
  }
}
